<template>
  <!-- 藏品详情 -->
  <div class="page-collect-detail">
    <div class="collect-swiper">
      <div class="g-content-wrap">
        <cmpSwiper ref="cmpSwiper" @refresh="getDetailData"></cmpSwiper>
      </div>
    </div>
    <div class="content-box g-content-wrap">
      <div class="content">
        <h2 class="title m-font-5">藏品简介</h2>
        <div class="g-detail-html trans" v-html="otherData.collectSynopsis"></div>
      </div>

      <div class="list-box">
        <h2 class="title m-font-5">相关展览</h2>
        <div class="list">
          <div class="item" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
            <div class="pic-box">
              <!-- <img v-lazy="item.picUrl" alt=""> -->
              <img v-lazy="item.relationId" alt="">
            </div>
            <div class="info">
              <h2>{{item.name}}</h2>
              <p class="three-ell">{{item.des}}</p>
              
              <!-- <my-cmp-like class="like-box" :isLike="item.collect==='1'?true:false" :likeId="'123'" :type="`2`"></my-cmp-like> -->
            </div>
          </div>
        </div>

        <div class="pages" v-show="mapQuery.totalPage && mapQuery.totalPage > 1">
          <!-- <div class="pages-l"><span>{{mapQuery.currentPage}}</span> / {{mapQuery.totalPage}}</div> -->
          <div class="pages-r" v-show="mapQuery.totalPage>1">
            <span class="btn btn-prev"
              :class="{'disabled': mapQuery.currentPage==1, 'border': mapQuery.currentPage>1&&mapQuery.currentPage<mapQuery.totalPage}"
              @click="handlePrev()">
              <i class="el-icon-arrow-left"></i>
            </span>
            
            <div class="pages-count"><span>{{mapQuery.currentPage}}</span> / {{mapQuery.totalPage}}</div>

            <span class="btn btn-next" :class="{'disabled': mapQuery.currentPage==mapQuery.totalPage}" @click="handleNext()">
              <i class="el-icon-arrow-right"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cmpSwiper from '@cmp/swiper'
export default {
  components: { cmpSwiper },
  name: 'collectDetail',
  inject: ['reload'],
  data() {
    return {
      detailId: this.$route.query.id,
      detailData: {},
      activeTab: 1,
      activeVal: '1',
      tabList: [
        {
          name: '曾经展出',
          val: '1'
        }
      ],
      dataList: [],
      mapQuery: {
        currentPage: 1,
        size: 3,
        totalPage: 0,
        total: 0
      },
      otherData: {},
      contactList: []
    }
  },
  methods: {
    getDetailData() {
      this.$http
        // .get('/collection/getCollectionById.do', {
        .get('../singleMuseum/collection/getCollectionById', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.result.baseCollectInfo
            this.otherData = res.result.otherCollectInfo
            

            this.$nextTick(() => {
              // this.initSwiper()
              this.$refs.cmpSwiper.init(this.detailData)
            })
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 相关展览
    getDataList() {
      this.$http
        .get('../singleMuseum/bs/bsWenwu/zhanLanList', {
          id: this.detailId,
          ...this.mapQuery,
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.result || {}
            this.dataList = data.records
            // this.total = data.total

            // this.dataList = res.data
            // this.mapQuery.total = res.page.allRow
            // this.mapQuery.totalPage = res.page.totalPage
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handlePrev() {
      if(this.mapQuery.currentPage > 1) {
        this.mapQuery.currentPage--
        this.getDataList()
      }
    },
    handleNext() {
      if(this.mapQuery.currentPage < this.mapQuery.totalPage) {
        this.mapQuery.currentPage++
        this.getDataList()
      }
    },
    initSwiper() {
      var galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        loop: true,
        nextButton: '.gallery-top .swiper-button-next',
        prevButton: '.gallery-top .swiper-button-prev',
      })
      var galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        loop: true,
        nextButton: '.gallery-thumbs .swiper-button-next',
        prevButton: '.gallery-thumbs .swiper-button-prev',
      })
      galleryTop.params.control = galleryThumbs
      galleryThumbs.params.control = galleryTop
    },
    clickTab(item) {
      console.log(this.tab)
      this.activeVal = item.val
    },
    goDetail(item) {
      this.reload()
      this.$router.push({
        path: '/exhibition/detail',
        query: {
          id: item.id,
          breadType: item.type
        }
      })
    },
    setBread() {
      // 动态修改面包屑
      console.log(11, this.pageType)
      this.pageType = this.$route.query.pageType || '1'
      switch(this.pageType) {
        case '1':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '馆藏精品',
              href: '/collect'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '2':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '3D藏品',
              href: '/collect/list'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '3':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '数字文物库',
              href: '/collect/digital-culture'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
      }
    }
  },
  created() {
    this.setBread()
    
    this.getDetailData()
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.page-collect-detail {
  padding-bottom: 40px;
  .collect-swiper {
    background: #F6F6F6;
    .g-content-wrap {
      padding: 40px 0;
      min-height: initial
    }
  }

  .content-box {
    // display: flex;
    justify-content: space-between;
    .title {
      margin-top: 50px;
      margin-bottom: 34px;
      // font-size: 24px;
      color: #000000;
    }
    .content {
      flex: 1;
      // /deep/ .g-detail-html {
      //   font-size: 18px;
      //   color: rgba($color: #000000, $alpha: 0.9);
      //   line-height: 32px;
      // }
    }
    .list-box {
      // margin-left: 40px;
      // width: 508px;
      width: 100%;
      .item {
        .pic-box {
          background: #f6f6f6;
          img {
            width: 100%;
            // height: 288px;
          }
        }
        .info {
          padding: 30px;
          margin-bottom: 20px;
          font-size: 26px;
          color: rgba($color: #000000, $alpha: 0.9);
          line-height: 45px;
          // background: #F6F6F6;
          h2 {
            font-size: 32px;
            color: #000000;
            margin-bottom: 20px;
          }
        }
      }
    }
  }

  .pages {
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    .pages-count {
      font-size: 14px;
      // font-weight: bold;
      color: #292423;
      line-height: 36px;
      // span {
      //   font-size: 36px;
      // }
    }
    .pages-r {
      display: flex;
      background: #FDFBEC;
      .btn {
        // display: inline-block;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 64px;
        height: 36px;
        // background:rgba(212,172,140,1);
        color: #292423;
        cursor: pointer;
        &.disabled {
          // background:rgba(212,172,140,.5);
          color: #bfbcbb;
        }
        &.border {
          // border-right: solid 1px $border;
        }
        .icon-triangle-prev {
          display: inline-block;
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-right: 6px solid #fff;
          border-bottom: 5px solid transparent;
        }
        .icon-triangle-next {
          display: inline-block;
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-left: 6px solid #fff;
          border-bottom: 5px solid transparent;
        }
      }
    }
  }
}
</style>


